// extracted by mini-css-extract-plugin
module.exports = {"dataScopeOption":"src-components-ChangeDataScopeModal-index-module__dataScopeOption--3AQIS"};